// extracted by mini-css-extract-plugin
export default {"content":"AppShell_content_k4zwL","theme":"AppShell_theme_C2R9P"};